module.exports = __webpack_public_path__ + "static/media/CAMARONTAUSI_MENU-normal.221c1d73.png";